"use strict";
import { IconManager } from "../../js/helpers/iconmanager";
import { clampQuantity } from "../../js/gamedata/quantityclamp";

ui.loadTemplateFile("quantitydialog.html");

class QuantityDialog extends Dialog {
    _element: any;
    _titleBar: any;
    _quantity: any;
    _price: any;
    _min: number;
    _max: number;
    _showPrice: boolean;
    _minPrice: number;
    _maxPrice: number;

    constructor(item: any, options: any) {
        super("quantitydialog.html");

        this._min = (options && options.min) || 1;
        this._max = (options && options.max) || 999;
        this._showPrice = !!(options && options.showPrice);
        this._minPrice = (options && options.minPrice) || 1;
        this._maxPrice = (options && options.maxPrice) || 2000000000;

        this._element
            .find(".item-icon")
            .append(IconManager.getItemIcon({ itemType: item.itemType, itemNo: item.itemNo, quantity: 1 }));
        this._element.find(".item-name").text(item.name);

        this._quantity = ui.textbox(this, ".textbox.quantity");
        this._quantity.text(String(this._min));

        this._price = ui.textbox(this, ".textbox.price");
        if (this._showPrice) {
            this._price.text(String(this._minPrice));
            this._element.find(".price-row").show();
        } else {
            // No [hidden]/display:none reset exists in style.less, and a
            // class selector like .price-row{display:flex} would beat the
            // native [hidden] UA rule anyway — use jQuery .hide()/.show()
            // (inline style, always wins), the same idiom Widget.hide()
            // itself uses, not the hidden attribute.
            this._element.find(".price-row").hide();
        }

        ui.button(this, ".button.confirm").on("clicked", this._onConfirm.bind(this));
        ui.button(this, ".button.cancel").on("clicked", this._onCancel.bind(this));

        this.center();
    }

    _onConfirm() {
        const quantity = clampQuantity(this._min, this._max, parseInt(this._quantity.text(), 10));
        this.close();
        if (this._showPrice) {
            const price = clampQuantity(this._minPrice, this._maxPrice, parseInt(this._price.text(), 10));
            this.emit("confirm", quantity, price);
        } else {
            this.emit("confirm", quantity);
        }
    }

    _onCancel() {
        this.close();
    }
}

ui.QuantityDialog = QuantityDialog;
ui.quantityDialog = function (item: any, options: any) {
    return new ui.QuantityDialog(item, options);
};
